import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import App from "./App";

const routes = (
  <CookiesProvider>
    <Router onUpdate={() => window.scrollTo(0, 0)}>
      <App />
    </Router>
  </CookiesProvider>
);

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js